<template>
  <div class="about">
    <div class="center">
      <div class="curmbs">
        <!-- <el-breadcrumb separator="/">
          <el-breadcrumb-item style="font-wei" :to="{ path: '/' }"
            ><span style="font-weight: 400">Home</span></el-breadcrumb-item
          >
          <el-breadcrumb-item
            ><a style="font-weight: 400" href="/"
              >Journals</a
            ></el-breadcrumb-item
          >
          <el-breadcrumb-item>PO</el-breadcrumb-item>
        </el-breadcrumb> -->
      </div>
      <div class="about-content">
        <div class="content-left">
          <asid-part />
        </div>
        <div class="content-right" v-loading="loading">
          <div class="text" v-html="contact"></div>
          <!-- <h1>About PiscoMed Publishing</h1>
          <p class="about-text" v-html="info"></p>
          <h1>Contact</h1>
          <div class="Singapore-text">
            <div v-for="(item, index) in contact" :key="index">
              <div v-html="item"></div>
            </div> -->
          <!-- <p>
              <i class="el-icon-postcard"></i>
              <span v-html="contact[0]"></span>
            </p>
            <p>
              <i class="el-icon-user-solid"></i>
              <span v-html="contact[1]"></span>
            </p>
            <p>
              <i class="el-icon-map-location"></i>
              <span v-html="contact.addr"></span>
            </p>
            <p>
              <i class="el-icon-phone"></i>
              <span v-html="contact.phone"></span>
            </p>
            <p>
              <i class="el-icon-message"></i>
              <span v-html="contact.email"></span>
            </p> -->
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import { getContact } from "@/api/common";
import asidPart from "@/components/asidPart";
export default {
  data() {
    return {
      info: "",
      contact: {},
      loading: false,
    };
  },
  components: {
    asidPart,
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.loading = true;
      getContact()
        .then((res) => {
          if (res.code == 200) {
            // this.info = res.data[0].content[0];
            // this.contact = res.data[2].content;
            this.contact = res.data;
            this.$nextTick(() => {
              let strongList = document.querySelectorAll(".text strong");
              let aList = document.querySelectorAll(".text a");
              Array.from(strongList).forEach((item) => {
                item.style.fontSize = "20px";
                item.style.borderLeft = "8px solid #2b90e8";
                item.style.paddingLeft = "12px";
                // item.classList.add("commonText");
                // item.style.lineHeight = "2.2em";
              });
              Array.from(aList).forEach((item) => {
                item.classList.add("linkStyle");
              });
            });
            // this.$nextTick(() => {
            //   let pList = document.querySelectorAll(".Singapore-text p");
            //   Array.from(pList).forEach((item) => {
            //     item.style.fontSize = "14px";
            //     item.style.lineHeight = "2.2em";
            //   });
            // });
          } else {
            this.$message.error(res.message);
          }
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.about {
  width: 100%;
  .center {
    width: 98%;
    max-width: 1400px;
    margin: auto;
    @media (max-width: 996px) {
      width: 100vw;
      max-width: 100vw;
    }
    .curmbs {
      height: 46px;
      display: flex;
      align-items: center;
      //   background: #ececec;
    }
    .about-content {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      .content-left {
        width: 17.2%;
        min-width: 220px;
        @media (max-width: 996px) {
          display: none;
        }
      }
      .content-right {
        width: 81.8%;
        border: 1px solid #ebeef5;
        background-color: #ffffff;
        box-sizing: border-box;
        padding: 30px 50px;
        border-radius: 8px;
        text-align: justify;
        @media (max-width: 996px) {
          width: 98vw;
          margin: auto;
          padding: 10px;
        }
        h1 {
          color: #000;
          padding-left: 12px;
          border-left: 8px solid #2b90e8;
          @media (max-width: 996px) {
            font-size: 17px;
          }
        }
        .about-text {
          font-size: 14px;
          line-height: 2.2em;
          color: #2b2b2b;
          margin: 20px auto;
          margin-left: 20px;
        }
        .Singapore-text {
          color: #2b2b2b;
          margin-left: 20px;

          p {
            line-height: 2.2em;
            font-size: 14px;
            display: flex;
            align-items: center;
            span {
              margin-left: 10px;
            }
          }
        }
      }
    }
  }
}
</style>
